import React from 'react';
import { useTranslation } from 'react-i18next';
import { Constants } from '@pwc/pwc-deals-web-common';
import StatusPill from './StatusPill';

export const VERSION_STATUS_I18N = {
  Undefined: 'pill.undefined',
  Draft: 'pill.draft',
  Review: 'pill.review',
  Shared: 'pill.shared',
  Publish: 'pill.publish',
  Archived: 'pill.archived',
  'For Approval': 'pill.forApproval',
  'Approval Rejected': 'pill.approvalRejected',
  Approved: 'pill.approved',
  'Shared with third party': 'pill.sharedWithThirdParty',
};
const ApprovalPill = ({ versionStatus, dataTestId = 'versionStatus' }) => {
  const { t } = useTranslation();
  const statusesToDisplay = [
    Constants.VERSION_STATUS.APPROVED,
    Constants.VERSION_STATUS.APPROVAL_REQUESTED,
  ].map((_) => _.value);

  const getI18nPillDisplayName = (_versionStatus) => {
    const displayName = Constants.getVersionStatus(_versionStatus);
    return t(VERSION_STATUS_I18N[displayName]);
  };
  return statusesToDisplay.includes(versionStatus) ? (
    <StatusPill
      dataTestId={dataTestId}
      title={getI18nPillDisplayName(versionStatus)}
    />
  ) : null;
};

export default ApprovalPill;
